export const getTotalDisplay = (total: number, range: [number, number]) => {
  return total === 1 ? `1~1 of 1 item` : `${range[0]}~${range[1]} of ${total} items`;
};
